// https://www.npmjs.com/package/is-relative-url

import { isAbsoluteUrl } from './isAbsoluteUrl';

export function isRelativeUrl(url: string, options: { allowProtocolRelative?: boolean } = {}) {
  const { allowProtocolRelative = true } = options;

  // Check if it's a protocol-relative URL (starts with //)
  if (!allowProtocolRelative && typeof url === 'string' && url.startsWith('//')) {
    return false;
  }

  return !isAbsoluteUrl(url);
}
